import { Box } from "@circleco/compass/components/Box";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import { useFormRenderingContext } from "../contexts/FormRenderingContext";

interface FormWrapperCompassProps {
  children: ReactNode;
}

export const FormWrapperCompass = ({ children }: FormWrapperCompassProps) => {
  const { formBackgroundColor, usage, pageBackgroundColor, renderType } =
    useFormRenderingContext();
  const { currentCommunity } = usePunditUserContext();

  const isStandaloneType = renderType === "standalone";
  const shouldShowPoweredBy =
    isStandaloneType && currentCommunity && !currentCommunity.white_label;

  if (!isStandaloneType && usage !== "newsletter") return <>{children}</>;

  if (usage === "newsletter")
    return (
      <Box
        className="h-fit w-full p-10"
        style={{ backgroundColor: formBackgroundColor }}
      >
        {children}
      </Box>
    );

  return (
    <main
      className="flex min-h-[100vh] h-fit w-full flex-col items-center gap-6 py-12"
      style={{ backgroundColor: pageBackgroundColor }}
    >
      <Box
        className="h-fit w-full max-w-[600px] p-10"
        style={{ backgroundColor: formBackgroundColor }}
      >
        {children}
      </Box>
      {shouldShowPoweredBy && (
        <a
          href="https://circle.so"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1"
        >
          <Typography component="span" variant="body-md" color="secondary">
            {t("powered_by")}
          </Typography>
          <Typography variant="label-md">{t("circle")}</Typography>
        </a>
      )}
    </main>
  );
};
